@if (hasMarkers) {
  <div class="tomass-map-toolbar">
    <div class="tomass-map-toolbar__group">
      <span class="tomass-map-toolbar__label">{{ i18n.metricLabel }}</span>
      <div class="tomass-map-toolbar__actions" role="group">
        <button
          type="button"
          class="tomass-map-toolbar__button"
          [class.is-active]="isMetricMode('scoreC')"
          (click)="setMetricMode('scoreC')"
        >
          {{ i18n.metricScoreC }}
        </button>
        <button
          type="button"
          class="tomass-map-toolbar__button"
          [class.is-active]="isMetricMode('seniorRatio')"
          (click)="setMetricMode('seniorRatio')"
        >
          {{ i18n.metricSeniorRatio }}
        </button>
        <button
          type="button"
          class="tomass-map-toolbar__button"
          [class.is-active]="isMetricMode('volume')"
          (click)="setMetricMode('volume')"
        >
          {{ i18n.metricVolume }}
        </button>
      </div>
    </div>

    <div class="tomass-map-toolbar__group">
      <span class="tomass-map-toolbar__label">{{ i18n.overlayLabel }}</span>
      <div class="tomass-map-toolbar__actions" role="group">
        <button
          type="button"
          class="tomass-map-toolbar__button tomass-map-toolbar__button--overlay"
          [class.is-active]="isOverlayEnabled('scoreC')"
          (click)="toggleOverlay('scoreC')"
        >
          {{ i18n.overlayScoreC }}
        </button>
        <button
          type="button"
          class="tomass-map-toolbar__button tomass-map-toolbar__button--overlay"
          [class.is-active]="isOverlayEnabled('seniorRatio')"
          (click)="toggleOverlay('seniorRatio')"
        >
          {{ i18n.overlaySeniorRatio }}
        </button>
        <button
          type="button"
          class="tomass-map-toolbar__button tomass-map-toolbar__button--overlay"
          [class.is-active]="isOverlayEnabled('volume')"
          (click)="toggleOverlay('volume')"
        >
          {{ i18n.overlayVolume }}
        </button>
      </div>
    </div>
  </div>
  <div #mapContainer class="tomass-map-container"></div>
} @else {
  <div class="tomass-map-empty">{{ i18n.noGeoData }}</div>
}
